import { useFormContext, useWatch } from "react-hook-form";
import { useIntl } from "react-intl";

import { classNames } from "helpers/commonHelpers";
import Input from "components/v2/Input/Input";

import "./PackingListCustomFieldInput.scss";

type PackingListCustomFieldInputProps = {
  name: string;
  fieldLabel?: string;
  showRequiredHint: boolean;
  onChange?: () => void;
};

export default function PackingListCustomFieldInput({
  name,
  fieldLabel,
  showRequiredHint,
  onChange,
}: Readonly<PackingListCustomFieldInputProps>) {
  const intl = useIntl();
  const { control } = useFormContext();
  const value = useWatch({ name, control });
  const hasValue = value !== null && value !== undefined && String(value).trim() !== "";
  const showRequiredOverlay = showRequiredHint && !hasValue;

  return (
    <div
      className={classNames("rfv2-packing-list-custom-field-input", {
        "rfv2-packing-list-custom-field-input--required": showRequiredOverlay,
        "rfv2-packing-list-custom-field-input--has-value": hasValue,
        "rfv2-packing-list-custom-field-input--labeled": Boolean(fieldLabel),
      })}
    >
      {fieldLabel ? <span className="rfv2-packing-list-custom-field-input__label">{fieldLabel}</span> : null}
      <Input name={name} hideError={showRequiredOverlay} onChange={onChange} />
      {showRequiredOverlay ? (
        <span className="rfv2-packing-list-custom-field-input__required">
          {intl.formatMessage({
            id: "request-form.packing-list.requiredHint",
            defaultMessage: "*Required",
          })}
        </span>
      ) : null}
    </div>
  );
}
